import { Alert } from '@mui/lab'
import { LinearProgress, TextField } from '@mui/material'
import React, { useState } from 'react'
import MainButton from '../common/util/input/MainButton'
import { post_admin } from '../helpers/Api'

export const AddPfpWl = ({ accountName, password }) => {
    const [mainnetCol, setMainnetCol] = useState(null)
    const [testnetCol, setTestnetCol] = useState(null)
    const [success, setSuccess] = useState(null)
    const [error, setError] = useState(null)
    const [isLoading, setIsLoading] = useState(false)

    const changeMainnet = (e) => {
        setSuccess(false)
        setError(false)
        setMainnetCol(e.target.value)
    }

    const changeTestnet = (e) => {
        setTestnetCol(e.target.value)
    }

    const parseResponse = (res) => {
        if (res && res['status'] === 200) {
            setSuccess(true)
            setError(false)
        }
        setIsLoading(false)
    }

    const parseError = () => {
        setSuccess(false)
        setError(true)
        setIsLoading(false)
    }

    const addToken = () => {
        setIsLoading(true)
        post_admin(
            'add-pfpwl',
            { mainnet: mainnetCol, testnet: testnetCol },
            accountName,
            password,
        )
            .then(parseResponse)
            .catch(parseError)
    }

    return (
        <div
            className={
                'm-4 p-4 border bg-zinc-300 dark:!bg-paper rounded-md shadow-xl h-full border-paperl'
            }
        >
            <div className={'font-bold text-xl'}>Add PFP Whitelist</div>
            <div className={'grid grid-cols-3'}>
                <div className={'m-4'}>
                    <TextField
                        size="small"
                        value={mainnetCol}
                        placeholder={'Mainnet Collection'}
                        inputProps={{
                            style: {
                                height: '1.2rem',
                                fontSize: '0.7rem',
                            },
                        }}
                        onChange={changeMainnet}
                        InputProps={{ tabIndex: 1 }}
                        error={!mainnetCol || mainnetCol.length > 12}
                    />
                </div>
                <div className={'m-4'}>
                    <TextField
                        size="small"
                        value={testnetCol}
                        placeholder={'Testnet Collection'}
                        inputProps={{
                            style: {
                                height: '1.2rem',
                                fontSize: '0.7rem',
                            },
                        }}
                        onChange={changeTestnet}
                        InputProps={{ tabIndex: 2 }}
                        error={testnetCol && testnetCol.length > 12}
                    />
                </div>
                <MainButton
                    className="btn"
                    onClick={addToken}
                    tabIndex={3}
                    disabled={isLoading}
                >
                    Add
                </MainButton>
            </div>
            {isLoading ? <LinearProgress /> : ''}
            {success ? (
                <Alert severity={'success'} onClose={() => setSuccess(false)}>
                    Collection whitelisted!
                </Alert>
            ) : (
                ''
            )}
            {error ? (
                <Alert severity={'error'} onClose={() => setError(false)}>
                    Unexpected Error
                </Alert>
            ) : (
                ''
            )}
        </div>
    )
}
